'use client';

import { useEffect, useRef } from 'react';

/**
 * Another tab moved the cart to another org, so a read here would move it
 * back. The provider seeds its fetching switch once, and a PDP sharing it
 * turns that on only after checking the org is current. When the cart comes
 * back to this org, reads resume.
 *
 * Call it below CartManagementProvider.
 */
export const useMiniCartReadsHeld = (
  isHeld: boolean,
  setEnableCartFetching: (enabled: boolean) => void
): void => {
  const wasHeldRef = useRef(false);

  useEffect(() => {
    if (isHeld) {
      wasHeldRef.current = true;
      setEnableCartFetching(false);
    } else if (wasHeldRef.current) {
      wasHeldRef.current = false;
      setEnableCartFetching(true);
    }
  }, [isHeld, setEnableCartFetching]);
};
